import { HttpService } from "../../modules/shared/services/http.service";
import { 
	ContactInfo, 
	ContactInfoCreateDto, 
	ContactInfoUpdateDto,
	ContactInfoBackendResponse,
	ContactInfoPaginatedResponse,
	ContactUsCreateDto,
	ContactUsUpdateDto,
	ContactUsBackendResponse,
	ContactUsPaginatedResponse,
	SocialLinkCreateDto,
	SocialLinkUpdateDto,
	SocialLinkBackendResponse,
	SocialLinkPaginatedResponse
} from "../../modules/shared/model/contact-info.interfaces";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Main ContactInfo Actions
export const createContactInfo = async (data: ContactInfoCreateDto): Promise<ContactInfoBackendResponse> => {
	const response = await HttpService.post("api/v1/contact-infos", data, headers, true);
	return response;
};

export const updateContactInfo = async (id: string, data: ContactInfoUpdateDto): Promise<ContactInfoBackendResponse> => {
	const response = await HttpService.patch(`api/v1/contact-infos/${id}`, data, headers, true);
	return response;
};

export const getContactInfoById = async (id: string): Promise<ContactInfoBackendResponse> => {
	const response = await HttpService.get(`api/v1/contact-infos/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getContactInfos = async (query?: Record<string, string | number | boolean>): Promise<ContactInfoPaginatedResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/contact-infos${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getContactInfoByCountry = async (countryId: string): Promise<ContactInfoBackendResponse> => {
	const response = await HttpService.get(`api/v1/contact-infos/country/${countryId}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteContactInfo = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/contact-infos/${id}`, { "x-custom-lang": "en" }, true);
};

// Contact Us Actions
export const createContactUs = async (data: ContactUsCreateDto): Promise<ContactUsBackendResponse> => {
	const response = await HttpService.post("api/v1/contact-us", data, headers, false);
	return response;
};

export const updateContactUs = async (id: string, data: ContactUsUpdateDto): Promise<ContactUsBackendResponse> => {
	const response = await HttpService.patch(`api/v1/contact-us/${id}`, data, headers, true);
	return response;
};

export const getContactUsById = async (id: string): Promise<ContactUsBackendResponse> => {
	const response = await HttpService.get(`api/v1/contact-us/${id}`, false, { "x-custom-lang": "en" });
	return response;
};

export const getContactUsMessages = async (query?: Record<string, string | number | boolean>): Promise<ContactUsPaginatedResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/contact-us${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteContactUs = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/contact-us/${id}`, { "x-custom-lang": "en" }, true);
};

// Social Links Actions
export const createSocialLink = async (data: SocialLinkCreateDto): Promise<SocialLinkBackendResponse> => {
	const response = await HttpService.post("api/v1/social-links", data, headers, true);
	return response;
};

export const updateSocialLink = async (id: string, data: SocialLinkUpdateDto): Promise<SocialLinkBackendResponse> => {
	const response = await HttpService.patch(`api/v1/social-links/${id}`, data, headers, true);
	return response;
};

export const getSocialLinkById = async (id: string): Promise<SocialLinkBackendResponse> => {
	const response = await HttpService.get(`api/v1/social-links/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getSocialLinks = async (query?: Record<string, string | number | boolean>): Promise<SocialLinkPaginatedResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/social-links${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getLatestSocialLink = async (): Promise<SocialLinkBackendResponse> => {
	const response = await HttpService.get("api/v1/social-links/social-link", true, { "x-custom-lang": "en" });
	return response;
};

export const getSocialLinkByType = async (typeId: number): Promise<SocialLinkBackendResponse> => {
	const response = await HttpService.get(`api/v1/social-links/social-link/type/${typeId}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteSocialLink = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/social-links/${id}`, { "x-custom-lang": "en" }, true);
};
